import datacentral from '@/utils/axios/datacentral'
import { ResponseArray, ResponseObject } from '@/types/shared'
import {
    CreateProductGroupVatRatePayload,
    ProductGroupVatRate,
    ProductGroupWithVatRates,
    UpdateProductGroupVatRatePayload,
} from '../types/product-group-vat'

const getBaseUrl = (code: string) => `/product-groups/${code}/vat-rates`

export const getAllVatRates = async (): Promise<ProductGroupWithVatRates[]> => {
    const response = await datacentral.get<
        ResponseArray<ProductGroupWithVatRates>
    >('/product-groups/vat-rates')
    return response.data.results || []
}

export const createVatRate = async (
    code: string,
    payload: CreateProductGroupVatRatePayload
): Promise<ProductGroupVatRate> => {
    const response = await datacentral.post<
        ResponseObject<ProductGroupVatRate>
    >(getBaseUrl(code), payload)
    return response.data.result
}

export const updateVatRate = async (
    code: string,
    vatRateId: number,
    payload: UpdateProductGroupVatRatePayload
): Promise<ProductGroupVatRate> => {
    const response = await datacentral.put<ResponseObject<ProductGroupVatRate>>(
        `${getBaseUrl(code)}/${vatRateId}`,
        payload
    )
    return response.data.result
}

export const deleteVatRate = async (
    code: string,
    vatRateId: number
): Promise<void> => {
    await datacentral.delete(`${getBaseUrl(code)}/${vatRateId}`)
}
